<template>
  <model-table
    :data="items"
    :noItemLabel="$t('compCarbonFormsVehiclesTable.no-vehicle')"
    :module="module"
    :disabled="isSubmitted"
    :singleUpdateDisabled="false"
    :bulkOpsDisabled="false"
    :withTags="authStore.isAuthenticated"
    @update="$emit('update')"
    @edit="(item) => $emit('edit', item)"
    @del="(items) => $emit('del', items)"
  >
    <b-table-column :label="$t('id')" field="name" sortable v-slot="props">
      {{ props.row.name }}
    </b-table-column>
    <b-table-column
      :label="$t('type')"
      field="type"
      sortable
      :custom-sort="sortType"
      v-slot="props"
    >
      <b-icon
        :pack="typeIconPack(props.row.type)"
        :icon="typeIcon(props.row.type)"
        style="padding-right: 20px"
      />
      {{ $t(props.row.type) }}
    </b-table-column>
    <b-table-column
      :label="$t('engine')"
      field="engine"
      sortable
      v-slot="props"
    >
      <span
        :class="{
          warning:
            props.row.engine === 'unknown.engine' && props.row.type !== 'car'
        }"
      >
        {{ $t(props.row.engine) }}
      </span>
    </b-table-column>
    <b-table-column
      :label="$t('consumption')"
      field="unit"
      numeric
      sortable
      :custom-sort="sortConsumption"
      v-slot="props"
    >
      <span :class="type(props.row.getConsumption())">
        {{ Math.round(props.row.getConsumption()) | splitNumber }}
      </span>
      <span :class="type(props.row.getConsumption())"
        >({{ props.row.unit }})</span
      >
    </b-table-column>
  </model-table>
</template>

<script>
import Vehicle from '@/models/carbon/Vehicle.js'
import Modules from '@/models/Modules.js'
import { useGHGIStore } from '@/stores/ghgi.js'
import { useAuthenticationStore } from '@/stores/authentication.js'

export default {
  name: 'Table',
  setup () {
    const ghgiStore = useGHGIStore()
    const authStore = useAuthenticationStore()
    return { ghgiStore, authStore }
  },
  props: {
    items: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  components: {
    'model-table': () => import('@/components/carbon/forms/ModelTable.vue')
  },
  computed: {
    module: function () {
      return Modules.VEHICLES
    },
    isSubmitted: function () {
      return this.ghgiStore.item.isSubmitted
    }
  },
  methods: {
    typeIcon: function (type) {
      return Vehicle.getIcon(type)
    },
    typeIconPack: function (type) {
      return Vehicle.getIconPack(type)
    },
    type: function (value) {
      const number = parseFloat(value)
      if (number === 0) {
        return 'warning'
      } else {
        return null
      }
    },
    sortStr (a, b, isAsc) {
      if (isAsc) {
        return a.localeCompare(b)
      } else {
        return b.localeCompare(a)
      }
    },
    sortStrToNum (a, b, isAsc) {
      if (isAsc) {
        return Number(a) - Number(b)
      } else {
        return Number(b) - Number(a)
      }
    },
    sortType (a, b, isAsc) {
      return this.sortStr(this.$t(a.type), this.$t(b.type), isAsc)
    },
    sortConsumption (a, b, isAsc) {
      return this.sortStrToNum(a.getConsumption(), b.getConsumption(), isAsc)
    }
  }
}
</script>
